/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    Container,
    Flex,
    Heading,
    Image,
    Grid,
    GridItem,
    HStack,
    Input,
    Stack,
    Link,
    useNumberInput,
    Spinner,
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    VStack,
  } from '@chakra-ui/react';
import axios from 'axios'
import CommonVars from "../components/CommonVars";
import { useParams } from "react-router-dom";

function CartScreen() {

    // states
    const [cartDetails, setCartDetails] = useState("");
    const [loading, setLoading] = useState(false);

    // Local storage data
    const xUserDetails = JSON.parse(localStorage.getItem('userDetails'));
    const xuserid = xUserDetails.userid;
    const xtoken = localStorage.getItem('token');

    const { cartid } = useParams();
 

    // for the input spinner
    const { getInputProps, getIncrementButtonProps, getDecrementButtonProps, cartQuantity } =

        useNumberInput({
        step: 1,
        defaultValue: '',
        min: 1,
        max: 999,
    });

    const inc = getIncrementButtonProps();
    const dec = getDecrementButtonProps();
    const input = getInputProps();

    // authorization
    if (xtoken == null || xUserDetails === false) {
		window.location.href = '/login';
    }

    // get the cart item details
    const getCartDetails = async () => {
        axios.get(`${CommonVars.API_URL}/users/${xuserid}/cart/${cartid}`, { headers: { Authorization: `Bearer ${xtoken}` } })
        .then((response) =>{
            setCartDetails(response.data[0]);
            console.log(response.data);
            setLoading(true);

        })
        .catch((error) =>{
            console.log(error);
        })
    }

    const { isOpen, onOpen, onClose } = useDisclosure();

    const checkout = (e) => {
        e.preventDefault();
        window.location.replace(`/users/${xuserid}/cart/${cartid}/address-details`);
    }

    useEffect(() => {
        getCartDetails();
    }, [])

    const CartDetailsArr = [];

        // prepare the request body for updating cart item quantity
        const cartQty = input.value
        const qtyReqBody = {
            quantity: cartQty
        }
        
        // update cart item quantity by cart id
        const updateQty = (event) => {
            event.preventDefault();
            console.log("cartid", cartid);
            axios.put(`${CommonVars.API_URL}/users/${xuserid}/cart/${cartid}/`, qtyReqBody, { headers: { Authorization: `Bearer ${xtoken}` } })
            .then((response) => {
                console.log(response);
                getCartDetails(); // -- "refresh"
            })
            .catch((error) => {
                console.log(error);
            });
        }

        CartDetailsArr.push(
            // individual cart item container
            <Container maxW = '100%' key={cartDetails.productid}>
                <Heading size = 'md'
                fontWeight={500}
                pb = '1.5rem'
                >Check your cart details, then proceed with checkout.
                </Heading>
                
                <Grid
                templateColumns='repeat(2, 1fr)'
                gap={3}
                >
                    {/* Product Image */}
                    <GridItem w='100%'>
                                <Box boxSize = {{
                                    base: '80px',
                                    sm: '80px',
                                    md: '100px',
                                    lg: '120px'
                                }}
                                margin = 'auto'
                                >
                                    <Image
                                        objectFit = "cover"
                                        boxSize = "100%"
                                        flex = {1}
                                        m='auto'
                                        src = {
                                            cartDetails.products_img_url
                                        }
                                    />
                                </Box>
                    </GridItem>

                    {/* cart item name, qty, and total price */}
                    <GridItem w = '83%' h='10'>
                        <Heading
                            size={'md'}
                            fontWeight = "700"
                            >
                                {cartDetails.name}
                        </Heading>

                        <Flex align = 'center'>
                            <Text>Quantity: &nbsp;</Text>
                            {/* Spinner */}
                            <HStack maxW='110px'> 
                            <Input
                                border = '1.3px solid black'
                                textAlign="center"
                                focusBorderColor='black'
                                placeholder={cartDetails.quantity}
                                {...input}
                            />

                            <Stack>
                                {/* Increment button */}
                                <Button
                                    onClick={updateQty}
                                    bg = 'white'
                                    color = 'black'
                                    _hover = {{
                                        bg: 'black',
                                        color: 'white',
                                    }}
                                    {...inc}
                                >
                                    +
                                </Button>
    
                                    {/* Decrement button */}
                                    <Button
                                    onClick={updateQty}
                                    bg = 'white'
                                    color = 'black'
                                    _hover = {{
                                        bg: 'black',
                                        color: 'white',
                                    }}
                                    {...dec}
                                >
                                    -
                                </Button>
                            </Stack>
                        </HStack>
                        </Flex>

                        <Flex>
                            <Text>
                                Total: &nbsp;
                            </Text>

                            <Heading size = {'md'} fontWeight={700}>
                                ${cartDetails.total}
                            </Heading>
                        </Flex>

                    </GridItem>

                </Grid>
                
                {/* Back button */}
                <Box
                    pt = '2rem'
                    mt = '1rem'
                >
                    <Link href={'/user/' + xuserid + '/carts'}>
                        <Button
                            bg = 'white'
                            color = 'black'
                            border = '2px solid black'
                            transition = '#ffffff .5s ease-in-out'
                            _hover = {{
                                bg: 'black',
                                color: 'white',
                                border: '2px solid black'
                            }}>
                                Back
                        </Button>
                    </Link>
                
                {/* Checkout button */}
                    <Button 
                        onClick={onOpen}
                        float = 'right'
                        bg = 'black'
                        color = 'white'
                        border = '2px solid black'
                        transition = '#ffffff .5s ease-in-out'
                        _hover = {{
                            bg: 'white',
                            color: 'black',
                            border: '2px solid black'
                        }}
                    >
                        Checkout - ${cartDetails.total}
                    </Button>

                    <Modal isOpen={isOpen} onClose={onClose} size={'sm'}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Checkout</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            Checkout this cart item?
                        </ModalBody>

                        <ModalFooter>
                            <Button 
                                border={'2px'}
                                bg = 'white'
                                color = 'black'
                                _hover = {{
                                    bg: 'black',
                                    color: 'white',
                                    border: '2px solid black'
                                }}
                                mr={3} 
                                onClick={onClose}
                            >
                                Cancel
                            </Button>
                            <Button 
                                border= '2px solid black'
                                bg = 'black'
                                color = 'white'
                                _hover = {{
                                    bg: 'white',
                                    color: 'black',
                                    border: '2px solid black'
                                }}
                                onClick={checkout}
                            >
                                Proceed
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                    </Modal>
                </Box>
                </Container>
        );

    return (
        <div className='Main'>
            <Heading>Cart Details</Heading>

            {/* loading animation */}
            {loading !== true ? 
                <Flex
                align = 'center'
                justify = 'center'>
                    <VStack align = "center">
                        <Spinner
                        thickness='9px'
                        speed='0.75s'
                        emptyColor='white'
                        color='black'
                        boxSize={24}/>
                            <Text
                            fontSize={18}
                            pt={6}>
                                Fetching Cart Item Details...
                            </Text>
                    </VStack>
                </Flex>
                :
            <Container
                maxW = {"2xl"}
                maxH = "100%"
                mt = "1.5rem"
                mb = '3rem'
                p = '3rem'
                bg = "white"
                boxShadow = 'lg'
                borderRadius = {{
                    base: '2rem',
                    sm: '2rem',
                    md: '3rem',
                    lg: '4rem'
                }}
                >
                    {/* cart items go here */}
                    {CartDetailsArr}
                </Container>
}


        </div>
    )
}

export default CartScreen;